import { Link as MuiLink } from '@mui/material'
import { AnchorHTMLAttributes, FC } from 'react'
import {
  Link as ReactRouterLink,
  LinkProps as ReactRouterLinkProps,
} from 'react-router-dom'
import { createDataset, isAbsoluteUrl } from '../../helpers/others'
import s from './Link.module.css'

const Link: FC<LinkProps> = (props) => {
  const { href, bold = false, onClick, ...passingProps } = props

  const baseProps = {
    className: s.root,
    ...createDataset({ bold }),
    onClick,
    ...passingProps,
  }

  return href && (typeof href !== 'string' || !isAbsoluteUrl(href)) ? (
    <MuiLink component={ReactRouterLink} to={href} {...baseProps} />
  ) : (
    <MuiLink href={href} {...baseProps} />
  )
}

type LinkProps = Pick<
  AnchorHTMLAttributes<HTMLAnchorElement>,
  'target' | 'onClick' | 'children'
> & {
  href?: ReactRouterLinkProps['to']
  bold?: boolean
}

export { Link }
export type { LinkProps }
